import React from "react";

import "./index.scss"; // Assurez-vous que le chemin est correct
export const Inconvenients = ({ inconvenients, description }) => {
  return (
    <section className="inconvenients-section text-center py-md-5 py-0">
      <h2 className="section-title">Inconvénients</h2>
      <p className="section-subtitle">{description}</p>
      <div className="container mt-4">
        <div className="row justify-content-center mt-5">
          {inconvenients.map((item, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-3 mb-4">
              <div className="inconvenients-card p-4">
                <div className="icon mb-3">{item.icon}</div>
                <p className="inconvenients-text mb-0">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
